/**
 * Reports Factory
 *
 * Factory pattern for dependency injection in Reports feature
 */

import {ReportsAPIDataSourceImpl} from '../api/ReportsAPIDataSource';
import {ReportsRepositoryImpl} from '../repository/ReportsRepositoryImpl';
import {GetMarketersUseCase} from '../useCases/GetMarketersUseCase';
import {GetMarketerStoresReportUseCase} from '../useCases/GetMarketerStoresReportUseCase';
import {GetMarketerFinancialReportUseCase} from '../useCases/GetMarketerFinancialReportUseCase';
import {ExportMarketerReportUseCase} from '../useCases/ExportMarketerReportUseCase';
import {GetMarketerStockReportUseCase} from '../useCases/GetMarketerStockReportUseCase';

export class ReportsFactory {
  private static apiDataSource: ReportsAPIDataSourceImpl;
  private static repository: ReportsRepositoryImpl;
  private static getMarketersUseCase: GetMarketersUseCase;
  private static getMarketerStoresReportUseCase: GetMarketerStoresReportUseCase;
  private static getMarketerFinancialReportUseCase: GetMarketerFinancialReportUseCase;
  private static exportMarketerReportUseCase: ExportMarketerReportUseCase;
  private static getMarketerStockReportUseCase: GetMarketerStockReportUseCase;

  static getAPIDataSource (): ReportsAPIDataSourceImpl {
    if (!this.apiDataSource) {
      this.apiDataSource = new ReportsAPIDataSourceImpl();
    }
    return this.apiDataSource;
  }

  static getRepository (): ReportsRepositoryImpl {
    if (!this.repository) {
      this.repository = new ReportsRepositoryImpl(this.getAPIDataSource());
    }
    return this.repository;
  }

  static getGetMarketersUseCase (): GetMarketersUseCase {
    if (!this.getMarketersUseCase) {
      this.getMarketersUseCase = new GetMarketersUseCase(this.getRepository());
    }
    return this.getMarketersUseCase;
  }

  static getGetMarketerStoresReportUseCase (): GetMarketerStoresReportUseCase {
    if (!this.getMarketerStoresReportUseCase) {
      this.getMarketerStoresReportUseCase = new GetMarketerStoresReportUseCase(this.getRepository());
    }
    return this.getMarketerStoresReportUseCase;
  }

  static getGetMarketerFinancialReportUseCase (): GetMarketerFinancialReportUseCase {
    if (!this.getMarketerFinancialReportUseCase) {
      this.getMarketerFinancialReportUseCase = new GetMarketerFinancialReportUseCase(this.getRepository());
    }
    return this.getMarketerFinancialReportUseCase;
  }

  static getExportMarketerReportUseCase (): ExportMarketerReportUseCase {
    if (!this.exportMarketerReportUseCase) {
      this.exportMarketerReportUseCase = new ExportMarketerReportUseCase(this.getRepository());
    }
    return this.exportMarketerReportUseCase;
  }

  static getGetMarketerStockReportUseCase (): GetMarketerStockReportUseCase {
    if (!this.getMarketerStockReportUseCase) {
      this.getMarketerStockReportUseCase = new GetMarketerStockReportUseCase(this.getRepository());
    }
    return this.getMarketerStockReportUseCase;
  }
}


